
import Vue from 'vue'
import ProductCarousel from '@/pages/top/components/ProductCarousel.vue'
import { TopProductItem } from '@/pages/top/types'

export default Vue.extend({
  name: 'HistoryProduct',
  components: {
    ProductCarousel
  },
  props: {
    historyProducts: {
      type: Array as () => TopProductItem[],
      required: true
    }
  },
   data() {
    return {
      carouselName: 'tp-HistoryProduct_Wrapper',
      currentPage: 0,
      totalPage: 0
    }
  },
  computed: {
    showCarouselBtn(): boolean {
      return this.historyProducts.length > 4
    }
  },
  methods: {
    updatePagerHandler(value: { currentPage: number, totalPage: number}) {
      this.currentPage = value.currentPage
      this.totalPage = value.totalPage
    }
  }
})
